import * as React from "react";
import { Link } from "react-router-dom";
import gql from "graphql-tag";

import BOTable, {
  BOColumn,
  BOColumns,
  BOBody,
  BORow,
  BOCell
} from "app/components/BOComponents/BOTable/BOTable";

import { DeviceFraudStatusIcon } from "./DeviceFraudStatusIcon";

import { formatDate } from "app/utils/filters";

type Props = { linkedUsers: any[] };

export const fragments = {
  linkedUserParts: gql`
    fragment LinkedUserParts on User {
      created_at
      external_reference
      email
      devices {
        created_at
        token
        phone_number
        external_reference
        suspicious_token_status
        suspicious_phone_number_status
      }
    }
  `
};

const LinkedUsersAndDeviceTable = ({ linkedUsers }: Props) => {
  const columns = (
    <BOColumns>
      <BOColumn>User date</BOColumn>
      <BOColumn>Email</BOColumn>
      <BOColumn>Device date</BOColumn>
      <BOColumn>Token</BOColumn>
      <BOColumn>Phone number</BOColumn>
    </BOColumns>
  );
  const body = (
    <BOBody>
      {linkedUsers.map((linkedUser, linkedUserIndex) => {
        const devices = linkedUser.devices;

        return devices.map((device, deviceIndex) => {
          return (
            <BORow key={`${linkedUserIndex}/${deviceIndex}`}>
              {deviceIndex === 0
                ? [
                    <BOCell key={1} rowSpan={devices.length}>
                      {formatDate(linkedUser.created_at)}
                    </BOCell>,
                    <BOCell key={2} rowSpan={devices.length}>
                      <Link
                        className="blueLink"
                        to={`/snapscan/ops/users/${
                          linkedUser.external_reference
                        }/payments`}
                      >
                        {linkedUser.email}
                      </Link>
                    </BOCell>
                  ]
                : null}
              <BOCell>{formatDate(device.created_at)}</BOCell>
              <BOCell>
                {device.token}&nbsp;<DeviceFraudStatusIcon
                  device={device}
                  fraudStatus={device.suspicious_token_status}
                />
              </BOCell>
              <BOCell>
                {device.phone_number}&nbsp;<DeviceFraudStatusIcon
                  device={device}
                  fraudStatus={device.suspicious_phone_number_status}
                />
              </BOCell>
            </BORow>
          );
        });
      })}
    </BOBody>
  );
  return (
    <BOTable
      name="linked_users_table"
      columns={columns}
      body={body}
      loading={false}
    />
  );
};

export default LinkedUsersAndDeviceTable;
